/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Menu from './Menu/index'
import MigrationModal from './MigrationModal/index'
import NewTaskOverlay from './NewTaskOverlay/index'
import React from 'react'
import TaskOverlay from './TaskOverlay/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Tasks/New"
  
}) {
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.selected.board_id"
 boardId={tabSelectedBoardIdValueData}
/>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-l16': dtColorsWhite,'--bc-6-l16': dtColorsNeutral400}}
 className={`views-block ${styles.Horizontal}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<NewTaskOverlay
  viewPath={`${viewPath}/NewTaskOverlay`}
/>
<TaskOverlay
  viewPath={`${viewPath}/TaskOverlay`}
/>
<MigrationModal
  viewPath={`${viewPath}/MigrationModal`}
/>
{children}
</React.Fragment>)
}